import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  withStyles,
  Stepper,
  Step,
  StepButton,
  Grid,
} from '@material-ui/core';

export const styles = () => ({ container: { margin: 5 } });

export class StatusInfoCardComponent extends React.Component {
  render() {
    return (
      <Grid container justify="center" className={this.props.classes.container}>
        <Grid item>
          <h3>
            <small>
              Event Status are used to bucketize events and track their progress through completion
            </small>
          </h3>
          <p>
            You can create any number, variation, and order of status.
            You have free range to customize status to meet the needs of your organization.
          </p>

          <h4>Name</h4>
          <div>
            <p>
              The name of a status is used for display purposes on dashboards
              and events.
            </p>
            <br />
            <p>
              Create status and names that meet the
              needs of your organization and events.
            </p>
          </div>

          <h4>Status Order</h4>
          <div>
            <p>
              Events flow through any number of status before they are
              completed. They are first created and then eventually completed,
              but often there are a series of status these events go through
              before it is complete.
            </p>
            <br />
            <p>
              You can place your status in any order you wish. Typically the order
              of status would match some logical flow leading up to the
              completion of an event. The order you place your status will also be
              used to display events in order on the dashboard.
            </p>
            <br />
            <Stepper alternativeLabel nonLinear>
              <Step key={1}>
                <StepButton>
                  New Event
                </StepButton>
              </Step>
              <Step key={2}>
                <StepButton>
                  Achnowledged
                </StepButton>
              </Step>
              <Step key={3}>
                <StepButton>
                  In Progress
                </StepButton>
              </Step>
              <Step key={4}>
                <StepButton>
                  Needs Review
                </StepButton>
              </Step>
              <Step key={5}>
                <StepButton>
                  Complete
                </StepButton>
              </Step>
              <Step key={6}>
                <StepButton>
                  Blocked
                </StepButton>
              </Step>
            </Stepper>
          </div>

          <h4>Autocomplete Status</h4>
          <div>
            <p>
              You can choose to label and tie a status as an
              <b> Autocomplete Status</b>.
            </p>
            <br />
            <p>
              A Status that is an <b>Autocomplete Status</b> will
              automatically complete an event whenever an event
              reaches that status. This can help save on time or mistakes
              in closing out or completing events.
            </p>
            <br />
            <p>
              More than one status can be an <b>Autocomplete Status</b>.
            </p>
          </div>

          <h4>Icon and Color</h4>
          <div>
            <p>
              To help distinguish between your different
              status, you can select a icon and color to each.
              This will be displayed along with the status name
              in the dashboards.
            </p>
          </div>

          <h4>Archiving</h4>
          <div>
            <p>
              You can archive status at any time. Archiving a status
              does not remove the status perminately, but instead will hide it from
              the dashboard. In addition, events will no longer be able to
              be moved to the status. You can always un-archive a status.
            </p>
            <br />
            <p>
              <b>Note</b> that you cannot archive a status which
              has active events in that status. You will first need
              to move those events to another status before archiving.
            </p>
          </div>
        </Grid>
      </Grid>
    );
  }
}

StatusInfoCardComponent.propTypes = { classes: PropTypes.object.isRequired };

export default connect()(withStyles(styles, { withTheme: true })(StatusInfoCardComponent));
